export default __webpack_public_path__ + "static/media/docker-registries.c6e1884c.png";